
export interface IOptionsDedupe
{
	includeScopes?: string[],
	includePackages?: string[],
	excludePackages?: string[],
	useMostCommon?: boolean,
}
